module.exports = __webpack_public_path__ + "header-profile-skin-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/patterns/header-profile-skin-1.png
// module id = 883
// module chunks = 11